import { useContext } from 'react';
import { AccountContext } from 'context/account';
import toAccountUrl from 'helpers/account/toAccountUrl';
import { useFormat } from 'helpers/hooks/useFormat';
import InfoCard from '../../../account-atoms/info-card';

const PersonalInfo = () => {
  const { formatMessage } = useFormat({ name: 'gruenland' });

  const { account } = useContext(AccountContext);

  const personalInformationFields: Array<{ label: string; value: string }> = [
    {
      label: formatMessage({ id: 'user.firstName', defaultMessage: 'Nome' }),
      value: account?.firstName as string,
    },
    { label: formatMessage({ id: 'user.lastName', defaultMessage: 'Cognome' }), value: account?.lastName as string },
    { label: formatMessage({ id: 'user.email', defaultMessage: 'Email' }), value: account?.email as string },
  ];

  return (
    <InfoCard
      title={formatMessage({ id: 'user.personalInfo', defaultMessage: 'Informazioni personali' })}
      isEditable
      infoFields={personalInformationFields}
      editHref={toAccountUrl('?hash=profile&id=edit-personal-info')}
    />
  );
};

export default PersonalInfo;
